export class DeviceProfiler {
  profile() {
    const memory = Number(navigator.deviceMemory || 4);
    const cores = Number(navigator.hardwareConcurrency || 4);
    const pixels = screen.width * screen.height * (devicePixelRatio || 1);
    const saveData = Boolean(navigator.connection?.saveData);
    let quality = 'medium';
    if (memory <= 4 || cores <= 4 || pixels > 5_000_000 || saveData) quality = 'low';
    else if (memory >= 8 && cores >= 8) quality = 'high';
    if (memory >= 16 && cores >= 12 && pixels < 7_000_000) quality = 'ultra';
    return { memory, cores, pixels, saveData, quality, webgpu: Boolean(navigator.gpu) };
  }
}
